<template>
  <split-view v-if="article.template !== 'article.footnote'">
    <template #english>
      <blocks v-if="article.english" :content="JSON.parse(article.english)" />
    </template>
    <template #chinese>
      <blocks v-if="article.chinese" :content="JSON.parse(article.chinese)" />
    </template>
  </split-view>
  <main class="view max-w-half" v-else>
    <div class="content pad">
      <blocks v-if="article.english" :content="JSON.parse(article.english)" />
    </div>
  </main>
</template>

<script>
const SplitView = () =>
  import(/* webpackChunkName: "View" */ "@/components/SplitView.vue");
const Blocks = () =>
  import(/* webpackChunkName: "Blocks" */ "@/components/Blocks.vue");
export default {
  name: "article-view",
  components: {
    SplitView,
    Blocks,
  },
  metaInfo() {
    return {
      title: "– " + this.article.title,
    };
  },
  computed: {
    article() {
      return this.$store.getters.getArticleByUID(this.$route.params.uid);
    },
  },
};
</script>
